"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M19.745 18.326A9.958 9.958 0 0022 12c0-5.523-4.477-10-10-10a9.968 9.968 0 00-3.906.792L9.34 4.453a8 8 0 019.16 12.213l1.245 1.66z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.42.56l16.5 22L18 24l-2.094-2.792c-1.2.51-2.52.792-3.906.792a9.965 9.965 0 01-4.064-.86l-5.921.845.846-5.92A9.965 9.965 0 012 12c0-2.4.846-4.603 2.255-6.326L1.5 2 3.42.56zm11.24 18.987L5.5 7.334A7.964 7.964 0 004 12c0 1.162.246 2.26.688 3.25l.234.527-.55 3.851 3.851-.55.526.235c.99.44 2.09.687 3.251.687.933 0 1.828-.16 2.66-.453z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;